<template>
    <b-card class="formation company-info">
        <loader v-if="isFetchingData" class="custom-loading" data-type="BulletListLoader" />
        
        <validation-observer v-else ref="companyInfoValidation">
            <!-- company information card -->
            <div class="align-items-center">
                <div>
                    <validation-provider
                        v-slot="{ errors }"
                        name="company name"
                        rules="required"
                        >
                        <div class="d-flex company-name">
                            <b-form-input
                            ref="companyName"
                            v-model="company.companyName"
                            name="companyName"
                            placeholder="Enter your company name"
                            data-test = "company-name"
                            :state="errors.length > 0 ? false : null"
                            @keydown="shouldShowCompanyAvailabilityStatus = false;"
                            @input="value => $store.commit('company/UPDATE_COMPANY_NAME', value)"
                            ></b-form-input>

                            <v-select
                                ref="companyType"
                                v-model="company.companyDomain"
                                label="text"
                                class="company-domain custom-select-icon"
                                variant="primary"
                                :options="companyDomainOptions"
                                :clearable="false"
                                :searchable="false"
                                @input="storeCompanyDomain"
                            />
                        </div>                        
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                     <!-- v-if="company.financialYearEnd" -->
                    <validation-provider
                        v-slot="{ errors }"
                        name="financial year end"
                        rules="required"
                    >
                        <b-form-group
                            label="Financial year end"
                            label-for="financial-year"
                            class="mt-2"
                            :state="errors.length > 0 ? false : null"
                        >
                            <flat-pickr
                                v-model="company.financialYearEnd"
                                placeholder="Select financial year end"
                                class="form-control"
                                :config="datePickerConfig"
                                data-test="financialYearEnd"
                            />
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                    <div class="row mt-2">
                        <div class="col-md-9 col-sm-6">
                            <!-- v-if="company.primaryBusinessActivity" -->
                            <validation-provider
                                v-slot="{ errors }"
                                name="Primary business activity"
                                class="end-align-indicator-middle-select"
                            >
                                <b-form-group
                                    label="Primary business activity"
                                    label-for="prmary-activity"
                                    class="mb-0"
                                    :state="errors.length > 0 ? false : null"
                                >
                                    <v-select
                                        id="primary-business-activity"
                                        ref="primary"
                                        v-model="company.primaryBusinessActivity"
                                        class="custom-select-icon"
                                        :clearable="false"
                                        placeholder="Select Primary Business Activity"
                                        label="text"
                                        :options="primaryActivityOptions"
                                        :selectable="
                                            (option) =>
                                                !option.hasOwnProperty('group')
                                        "
                                    >
                                        <template #option="{ group, text }">
                                            <div v-if="group" class="group">
                                                <span class="d-none">{{
                                                    group
                                                }}</span>
                                                {{ text }}
                                            </div>
                                        </template>
                                    </v-select>
                                </b-form-group>

                                <small class="text-danger">{{
                                    errors[0]
                                }}</small>
                            </validation-provider>
                        </div>

                        <div>
                            <!-- v-if="activePrimarySSIC" -->
                            <b-form-group
                                label="Primary business SSIC"
                                label-for="primary-business-ssic"
                                class="mb-0 business-ssic-form-group"
                            >
                                <b-form-input
                                    :value="activePrimarySSIC"
                                    placeholder="00000"
                                    :disabled="true"
                                    class="business-ssic text-center"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-9 col-sm-6">
                             <!-- v-if="company.secondaryBusinessActivity" -->
                            <validation-provider
                                v-slot="{ errors }"
                                name="Secondary business activity"
                            >
                                <!-- :rules="{ required: required, vselect: true }" -->
                                <b-form-group
                                    label="Secondary business activity"
                                    label-for="secondary-business-ssic"
                                    :state="errors.length > 0 ? false : null"
                                    class="end-align-indicator-middle-select"
                                >
                                    <v-select
                                        id="secondary-business-activity"
                                        ref="secondary"
                                        v-model="company.secondaryBusinessActivity"
                                        class="custom-select-icon"
                                        :clearable="false"
                                        placeholder="Select Secondary Business Activity"
                                        label="text"
                                        :options="secondaryActivityOptions"
                                        :selectable="
                                            (option) => !option.hasOwnProperty('group')
                                        "
                                    >
                                        <template #option="{ group, text }">
                                            <div v-if="group" class="group">
                                                <span class="d-none">{{ group }}</span>
                                                {{ text }}
                                            </div>
                                        </template>
                                    </v-select>
                                </b-form-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </div>

                        <div>
                            <!-- v-if="activeSecondarySSIC" -->
                            <b-form-group
                                label="Secondary business SSIC"
                                label-for="secondary-activity"
                                class="business-ssic-form-group"
                            >
                                <b-form-input
                                    :value="activeSecondarySSIC"
                                    placeholder="00000"
                                    :disabled="true"
                                    class="business-ssic text-center"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>

                    <!-- v-if="company.shareType" -->
                    <b-form-group
                        label="Share type"
                        label-for="share-type"
                        class="mt-1"
                    >
                        <b-form-input
                            v-model="company.shareType.name"
                            placeholder="Choose share type"
                            class="dark-disabled"
                            disabled
                        ></b-form-input>
                    </b-form-group>

                    <!-- v-if="company.totalShare" -->
                    <validation-provider
                        v-slot="{ errors }"
                        name="number of shares"
                        rules="required"
                    >
                        <b-form-group
                            label="Total number of shares"
                            label-for="no-of-shares"
                            class="mt-2"
                        >
                            <b-form-input
                                ref="noOfShares"
                                v-model="company.totalShare"
                                v-mask="shareMask"
                                placeholder="Enter total number of shares"
                                data-test="noOfShares"
                                :state="errors.length > 0 ? false : null"
                                type="text"
                                no-wheel
                                @keydown.up.prevent
                                @keydown.down.prevent
                            ></b-form-input>
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                     <!-- v-if="capitalCurrencyOptions.length >= 1" -->
                    <b-form-group
                        label="Paid up capital currency"
                        label-for="capital-currency"
                        class="mt-2 end-align-indicator-long-select"
                    >
                        <v-select
                            id="capital-currency"
                            ref="capitalCurrency"
                            v-model="company.capitalCurrency"
                            placeholder="Select your currency"
                            label="code"
                            :clearable="false"
                            :options="capitalCurrencyOptions"
                        ></v-select>
                    </b-form-group>

                    <!-- v-if="company.capitalAmount" -->
                    <validation-provider
                        v-slot="{ errors }"
                        name="capital amount"
                        rules="required"
                    >
                        <b-form-group
                            label="Paid up captial amount"
                            label-for="capital-amount"
                            class="mt-2"
                        >
                            <b-form-input
                                ref="capitalAmount"
                                v-model="company.capitalAmount"
                                v-mask="amountMask"
                                placeholder="Enter paid up capital amount"
                                name="capitalAmount"
                                type="text"
                                data-test="capitalAmount"
                                :state="errors.length > 0 ? false : null"
                                no-wheel
                                @keydown.up.prevent
                                @keydown.down.prevent
                            ></b-form-input>
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                     <!-- v-if="company.issuedCapitalAmount" -->
                    <validation-provider
                        v-slot="{ errors }"
                        name="issued share capital amount"
                        rules="required"
                    >
                        <b-form-group
                            label="Issued share capital amount"
                            label-for="issued-capital-amount"
                            class="mt-2"
                        >
                            <b-form-input
                                ref="issuedCapitalAmount"
                                v-model="company.issuedCapitalAmount"
                                v-mask="amountMask"
                                placeholder="Enter issued share capital amount"
                                name="issuedCapitalAmount"
                                type="text"
                                data-test="issuedCapitalAmount"
                                :state="errors.length > 0 ? false : null"
                                no-wheel
                                @keydown.up.prevent
                                @keydown.down.prevent
                            ></b-form-input>
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                    <!-- v-if="company.address.address" -->
                    <validation-provider
                        v-slot="{ errors }"
                        name="address"
                        rules="required"
                    >
                        <b-form-group
                            label="Address"
                            label-for="address"
                            class="mt-2"
                        >
                            <b-form-textarea
                                v-model="company.address.address"
                                placeholder="Enter company address"
                                :state="errors.length > 0 ? false : null"
                                data-test="address" 
                            ></b-form-textarea>
                                <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </div>
            </div>
        </validation-observer>

        <div class="d-flex justify-content-end mt-3">
            <b-button
                v-show="false"
                variant="outline-primary"
                :to="{ name: '' }"
            >
                <img :src="'/icons/left-arrow.svg'" alt="left-arrow" />
                Previous
            </b-button>

            <b-button
variant="primary" data-test="next"
                :disabled="loading || isFetchingData"
                class=" d-flex justify-content-center next-button align-items-center" 
                @click="save"
            >
                Next
                <normal-loader v-if="loading" class="custom-loading ml-.5" />
                <img v-else :src="'/icons/right-arrow.svg'" class="ml-.5" alt="right-arrow" />
            </b-button>

        </div>
    </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import vSelect from "vue-select";
import { required } from "@validations";
import { BCard, BButton, BFormInput, BFormGroup, BFormTextarea } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";

import {
    companyType,
    getBusinessActivities,
    getCurrencies,
} from "@/apis/company";
import Formation from '@/models/Formation';
import { errorToast } from '@/views/helpers/toast';
import { COMPANY_INFORMATION } from '@/constants/config';
import { formatDate, shareMask, amountMask, unMask, formatFloat } from '@/helpers';

extend("vselect", {
    validate: data => {
        const { value } = data;
        // return value !== undefined && value !== null && Object.keys(value).length > 0;
        if (value === "default") return false;

        return value;
    },
});

export default {
    components: {
        BCard,
        BButton,
        BFormInput,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        vSelect,
        BFormTextarea,
        flatPickr,
    },

    data() {
        return {
            company: {},
            required,
            primaryActivityOptions: [],

            secondaryActivityOptions: [],

            activity_ssic: [],
            companyDomainOptions: [],
            capitalCurrencyOptions: [],
            datePickerConfig: {
                altFormat: "j M Y",
                dateFormat: "j M Y",
                disableMobile: "true"
            },

            loading: false,
            isFetchingData: true,

            maskKeys: ['issuedCapitalAmount', 'capitalAmount', 'totalShare'],
            shareMask,
            amountMask,
        };
    },

    computed: {
        activePrimarySSIC() {
            const activity = this.activity_ssic.filter(
                ssic => ssic.id === (this.company.primaryBusinessActivity && this.company.primaryBusinessActivity.value)
            );

            if (activity.length > 0) return activity[0].ssic;
            return "00000";
        },

        activeSecondarySSIC() {
            const activity = this.activity_ssic.filter(
                ssic => ssic.id === (this.company.secondaryBusinessActivity && this.company.secondaryBusinessActivity.value)
            );

            if (activity.length > 0) return activity[0].ssic;
            return "00000";
        },
    },

    async mounted() {
        this.isFetchingData = true;

        // get business activities
        const activities = await getBusinessActivities();
        this.primaryActivityOptions = activities;
        
        const secondaryOptions = [
            {
                text: 'Select Secondary Business Activity',
                value: 0
            },
            ...activities
        ];

        this.secondaryActivityOptions= secondaryOptions;

        activities.map(activity => {
            if (activity.value)
            {
                const {value} = activity;

                this.activity_ssic.push({
                    id: value,
                    ssic: activity.ssic
                });

                return true;
            }

            return false;
        });

        // get currencies
        const currencies = await getCurrencies();
        
        this.capitalCurrencyOptions = currencies.map(currency => ({
            value: currency.id,
            name: currency.name,
            code: currency.currency_code,
        }));

        // get company type
        const data = await companyType();

        this.companyDomainOptions = data.map(obj => {
            const value = obj.id;
            const text = obj.name;

            // console.log(obj.name);
            if (text === COMPANY_INFORMATION.DEFAULT_COMPANY_DOMAIN)
            {
                // update company domain in store
                // this.$store.commit('company/UPDATE_COMPANY_DOMAIN', { 
                //     text,
                //     value,
                //     id: value,
                //     name: text
                // });
            }

            return { value, text };
        });
        
        if(this.company.companyDomain.name)
            // eslint-disable-next-line prefer-destructuring
            this.company.companyDomain.name = this.companyDomainOptions.filter(
                opt => opt.value === this.company.companyDomain.id
            )[0];
           
        this.isFetchingData = false;
    },

    created() {
        Formation
            .getCompanyInformation()
            .then(companyInformation => {
                this.company = this.localizeCompanyInformation(companyInformation);
            }).catch(e => {
                console.error('Error while trying to fetch companies information', e);
                errorToast(e);
            });

        if (process.env.NODE_ENV !== "testing")
            document.getElementById("app").scrollIntoView();
    },

    methods: {
        localizeCompanyInformation(companyInfo) {
            return {
                companyName : companyInfo.name,
                companyDomain: {
                    value: companyInfo?.company_type?.id,
                    text: companyInfo?.company_type?.name
                },
                financialYearEnd: formatDate(companyInfo.year_end),
                primaryBusinessActivity: {
                    value: companyInfo?.primary_business_activity?.id,
                    text: companyInfo?.primary_business_activity?.name
                },
                primarySSIC: companyInfo.primary_business_activity?.SSIC,
                secondaryBusinessActivity: {
                    value: companyInfo?.secondary_business_activity?.id,
                    text: companyInfo?.secondary_business_activity?.name
                },
                secondarySSIC: companyInfo?.secondary_business_activity?.SSIC,
                shareType: {
                    value: companyInfo?.share_capital?.share_type?.id,
                    name: companyInfo?.share_capital?.share_type?.name
                },
                totalShare: companyInfo?.share_capital?.number_of_shares,
                capitalCurrency: {
                    value: companyInfo?.share_capital.currency?.id,
                    name: companyInfo?.share_capital.currency?.name,
                    code: companyInfo?.share_capital.currency?.currency_code
                },
                capitalAmount: formatFloat(companyInfo?.share_capital?.capital_amount),
                issuedCapitalAmount: formatFloat(companyInfo?.share_capital?.issued_amount),
                address: {
                    address: companyInfo.address?.address,
                },
            };
        },

        save() {
            // this.company.companyDomain.id = this.company.companyDomain.name.value;
            this
                .$refs
                .companyInfoValidation
                .validate()
                .then(async success => {
                    if (success) 
                    {
                        this.loading = true;

                        await Formation.updateCompanyInformation(unMask(this.company, this.maskKeys));
                        this.$emit('next');
                        
                        this.loading = false;
                    }
                }).catch(e => {
                    console.error(e);
                    this.loading = false;
                });
        },

        storeCompanyDomain(option) {
            // const result = this.companyDomainOptions.find(domain => domain.value === option);
            this.$store.commit("company/UPDATE_COMPANY_DOMAIN", {
                text: option.text,
                value: option.value,
                id: option.value,
                name: option.text
            });
        },
    },
};
</script>

<style lang="scss">
.company-info .company-domain.v-select.vs--single .vs__selected {
    color: #fff;
}

.business-ssic {
    font-size: 15px;
}

@import "@core/scss/vue/libs/vue-flatpicker.scss";

.flatpickr-day.selected {
    background: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
}

.vs__dropdown-option--disabled {
    opacity: 1 !important;
    padding-left: 1rem !important;
    font-size: 1.2rem !important;
    .group {
        color: #6e6b7b !important;
        font-weight: bold !important;
    }
}

.formation .business-ssic-form-group {
    width: 13rem;
    font-size: 15px;

    input {
        letter-spacing: 1em;
    }
}

.vs__selected-options {
    height: 29px;
    width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-basis: 90% !important;
    flex-grow: 0 !important;
}

.company-info .company-name .vs__dropdown-toggle {
    border-color: #4267b2;
    border-radius: 0.357rem;
}
</style>
